import * as React from 'react';
import 'isomorphic-fetch';
import { BlogDetails } from "./BlogDetails";
export class Blog extends React.Component {
    constructor() {
        super();
        this.state = { loading: true, blogDetailsId: -1, blogs: null };
        fetch('Data/GetBlogs', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            this.setState({ loading: false, blogDetailsId: -1, blogs: data });
        });
    }
    render() {
        let result = React.createElement("div", null);
        if (this.state.loading) {
            result = React.createElement("div", null, "Fetching blog list...");
        }
        else if (this.state.blogDetailsId != -1) {
            result = React.createElement("div", null,
                React.createElement(BlogDetails, { blogId: this.state.blogDetailsId }),
                React.createElement("br", null),
                React.createElement("button", { className: "btn btn-primary", onClick: () => this.onGoBackClicked() }, "Go back"));
        }
        else {
            let imagesSection = React.createElement("table", { className: 'table' },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Id"),
                        React.createElement("th", null, "Title"),
                        React.createElement("th", null, "Date"),
                        React.createElement("th", null, "Posted By"),
                        React.createElement("th", null, "Actions"))),
                React.createElement("tbody", null, this.state.blogs.map(blog => {
                    return React.createElement("tr", { key: blog.id },
                        React.createElement("td", null, blog.id),
                        React.createElement("td", null, blog.title.data),
                        React.createElement("td", null, blog.date),
                        React.createElement("td", null, blog.postedBy),
                        React.createElement("td", null,
                            React.createElement("button", { className: "btn btn-primary", onClick: () => this.onBlockDetailsClick(blog.id) }, "Details")));
                })));
            result = React.createElement("div", null, imagesSection);
        }
        return result;
    }
    onBlockDetailsClick(blogId) {
        this.setState({ loading: this.state.loading, blogDetailsId: blogId, blogs: this.state.blogs });
    }
    onGoBackClicked() {
        this.setState({ loading: this.state.loading, blogDetailsId: -1, blogs: this.state.blogs });
    }
}
//# sourceMappingURL=Blog.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/Blog/Blog.js
// module id = 88
// module chunks = 0